import { Route } from "react-router-dom";
import SubscriptionCreate from "./pages/SubscriptionCreate";
import SubscriptionList from "./pages/SubscriptionList";

/**
 * This will return all routes for the specific module
 */
const MODULE_ROUTE = "subscription"; 
const SubscriptionRoute = [
    <Route path={`${MODULE_ROUTE}`} element={<SubscriptionList />} key={`${MODULE_ROUTE}_index`} />,
    // <Route path={`${MODULE_ROUTE}/create`} element={<SubscriptionCreate />}  key={`${MODULE_ROUTE}_create`}  />,
    <Route path={`${MODULE_ROUTE}/update/:id`} element={<SubscriptionCreate />} key={`${MODULE_ROUTE}_edit`} />,
  ];

export default SubscriptionRoute;